/* eslint-disable */
/*
  oJo, no hacer multininea.

  oJo, poner raiz la categoría: ej.-
     Blockly.Msg["SENSOR_(nombre del mensaje)"]

  oJo, no sacar literales aunque se dupliquen (son pocas): ej.-
     Blockly.Msg["COPY_TO_BACKPACK"] = "Copiar a la motchila"; <- OK
     Blockly.Msg["COPY"] = "Copiar";                           <- NO OK
     Blockly.Msg["BACKPACK"] = "motchila";                     <- NO OK

  oJo, hacer las modificaciones en los 4 diomas a la vez!!!,
    la idea es que coincidan línea a línea,
    no dejar una traducción hecha en un idioma y no en el resto.
*/

import Blockly from "blockly";

export function AES() {
  Blockly = {};
  Blockly.Msg = {};

  // Blocks - COMMON
  Blockly.Msg["ADD_NEW_LINE"] = "Salto de línea";
  Blockly.Msg["AS"] = "como";
  Blockly.Msg["BAUDRATE"] = "Baudios";
  Blockly.Msg["BOOLEAN_FALSE"] = "falso";
  Blockly.Msg["BOOLEAN_OFF"] = "OFF";
  Blockly.Msg["BOOLEAN_ON"] = "ON";
  Blockly.Msg["BOOLEAN_TRUE"] = "verdadero";
  Blockly.Msg["COL"] = "Columna";
  Blockly.Msg["COLOUR"] = "Color";
  Blockly.Msg["DO"] = "hacer";
  Blockly.Msg["FIX"] = "Fijar";
  Blockly.Msg["I2C_ADDRESS"] = "Dirección";
  Blockly.Msg["I2C_BEGIN"] = "Iniciar (I2C)";
  Blockly.Msg["ID"] = "#";
  Blockly.Msg["PIN"] = "PIN";
  Blockly.Msg["ROW"] = "Fila";
  Blockly.Msg["STATUS"] = "Estado";
  Blockly.Msg["TIMEOUT"] = "tiempo máximo";
  Blockly.Msg["UNTIL_NEW_LINE"] = "Hasta salto de línea";
  Blockly.Msg["VALUE"] = "Valor";
  Blockly.Msg["DEFAULT_VAR_NAME"] = "varNum";
  Blockly.Msg["UPLOAD"] = "Subir";

  // Blocks - LOGIC
  Blockly.Msg["LOGIC_BOOLEAN_FALSE"] = Blockly.Msg["BOOLEAN_FALSE"];
  Blockly.Msg["LOGIC_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["LOGIC_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["LOGIC_BOOLEAN_TOOLTIP"] = "Devuelve verdadero o falso.";
  Blockly.Msg["LOGIC_BOOLEAN_TRUE"] = Blockly.Msg["BOOLEAN_TRUE"];
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_EQ"] = "Devuelve verdadero si ambas entradas son iguales.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GT"] = "Devuelve verdadero si la primera entrada es mayor que la segunda entrada.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GTE"] = "Devuelve verdadero si la primera entrada es mayor o igual a la segunda entrada.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LT"] = "Devuelve verdadero si la primera entrada es menor que la segunda entrada.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LTE"] = "Devuelve verdadero si la primera entrada es menor que o igual a la segunda entrada.";
  Blockly.Msg["LOGIC_COMPARE_TOOLTIP_NEQ"] = "Devuelve verdadero si ambas entradas son distintas.";
  Blockly.Msg["LOGIC_NEGATE_TITLE"] = "no %1";
  Blockly.Msg["LOGIC_NEGATE_TOOLTIP"] = "Devuelve verdadero si la entrada es falsa. Devuelve falso si la entrada es verdadera.";
  Blockly.Msg["LOGIC_OPERATION_AND"] = "y";
  Blockly.Msg["LOGIC_OPERATION_OR"] = "o";
  Blockly.Msg["LOGIC_OPERATION_TOOLTIP_AND"] = "Devuelve verdadero si ambas entradas son verdaderas.";
  Blockly.Msg["LOGIC_OPERATION_TOOLTIP_OR"] = "Devuelve verdadero si al menos una de las entradas es verdadera.";
  Blockly.Msg["LOGIC_IF_MSG_ELSE"] = "sino";
  Blockly.Msg["LOGIC_IF_MSG_ELSEIF"] = "sino si";
  Blockly.Msg["LOGIC_IF_MSG_IF"] = "Si";
  Blockly.Msg["LOGIC_IF_MSG_THEN"] = Blockly.Msg["DO"];
  Blockly.Msg["LOGIC_IF_TOOLTIP"] = "Si la comparación es cierta, ejecuta los bloques asociados.";

  // Blocks - CONTROLS
  Blockly.Msg["CONTROLS_FOR_TITLE"] = "Contar con %1 desde %2 hasta %3 de a %4";
  Blockly.Msg["CONTROLS_FOR_TOOLTIP"] = 'Hacer que la variable "%1" tome los valores desde el número de inicio hasta el número final, contando con el intervalo especificado, y hacer los bloques especificados.';
  Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"] = Blockly.Msg["DO"];
  Blockly.Msg["CONTROLS_REPEAT_TITLE"] = "Repetir %1 veces";
  Blockly.Msg["CONTROLS_REPEAT_TOOLTIP"] = "Hacer algunas declaraciones varias veces.";
  Blockly.Msg["CONTROLS_WHILEUNTIL_INPUT_DO"] = Blockly.Msg["DO"];
  Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_UNTIL"] = "Repetir hasta";
  Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_WHILE"] = "Repetir mientras";
  Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL"] = "Mientras un valor sea falso, entonces hacer algunas declaraciones.";
  Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_WHILE"] = "Mientras un valor sea verdadero, entonces hacer algunas declaraciones.";
  Blockly.Msg["CONTROLS_ARDUINO_LOOP"] = "Bucle";
  Blockly.Msg["CONTROLS_ARDUINO_SETUP"] = "Inicializar";
  Blockly.Msg["CONTROLS_GROUP"] = "Agrupar";

  // Blocks - MATH
  Blockly.Msg["MATH_ADDITION_SYMBOL"] = "+";
  Blockly.Msg["MATH_ANGLE"] = "ángulo";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_ADD"] = "Devuelve la suma de ambos números.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_DIVIDE"] = "Devuelve el cociente de ambos números.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MINUS"] = "Devuelve la diferencia de ambos números.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MULTIPLY"] = "Devuelve el producto de ambos números.";
  Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_POWER"] = "Devuelve el primer número elevado a la potencia del segundo.";
  Blockly.Msg["MATH_CHANGE_TITLE"] = "Cambiar %1 por %2";
  Blockly.Msg["MATH_CHANGE_TITLE_ITEM"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["MATH_CHANGE_TOOLTIP"] = "Añadir un número a la variable «%1».";
  Blockly.Msg["MATH_CONSTRAIN_TITLE"] = "limitar %1 entre %2 y %3";
  Blockly.Msg["MATH_CONSTRAIN_TOOLTIP"] = "Limitar un número entre los límites especificados (inclusive).";
  Blockly.Msg["MATH_DIVISION_SYMBOL"] = "÷";
  Blockly.Msg["MATH_MAP_TITLE"] = "mapear %1 de %2 - %3 a %4 - %5";
  Blockly.Msg["MATH_MAP_TOOLTIP"] = "Mapear un número de un rango a otro";
  Blockly.Msg["MATH_MODULO_TITLE"] = "resto de %1 ÷ %2";
  Blockly.Msg["MATH_MODULO_TOOLTIP"] = "Devuelve el resto al dividir los dos números.";
  Blockly.Msg["MATH_MULTIPLICATION_SYMBOL"] = "×";
  Blockly.Msg["MATH_NUMBER_TOOLTIP"] = "Un número.";
  Blockly.Msg["MATH_POWER_SYMBOL"] = "^";
  Blockly.Msg["MATH_RANDOM_INT_TITLE"] = "entero aleatorio de %1 a %2";
  Blockly.Msg["MATH_RANDOM_INT_TOOLTIP"] = "Devuelve un entero aleatorio entre los dos límites especificados, inclusive.";
  Blockly.Msg["MATH_SINGLE_OP_ABSOLUTE"] = "absoluto";
  Blockly.Msg["MATH_SINGLE_OP_LN"] = "log(e)";
  Blockly.Msg["MATH_SINGLE_OP_LOG10"] = "log(10)";
  Blockly.Msg["MATH_SINGLE_OP_NEG"] = "-";
  Blockly.Msg["MATH_SINGLE_OP_ROOT"] = "raíz cuadrada";
  Blockly.Msg["MATH_SINGLE_OP_ROUND"] = "redondear";
  Blockly.Msg["MATH_SINGLE_OP_ROUNDDOWN"] = "redondear hacia abajo";
  Blockly.Msg["MATH_SINGLE_OP_ROUNDUP"] = "redondear hacia arriba";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ABS"] = "Devuelve el valor absoluto de un número.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_EXP"] = "Devuelve e a la potencia de un número.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_LN"] = "Devuelve el logaritmo natural de un número.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_LOG10"] = "Devuelve el logaritmo base 10 de un número.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_NEG"] = "Devuelve la negación de un número.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_POW10"] = "Devuelve potencia en base 10 de un número.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROOT"] = "Devuelve la raíz cuadrada de un número.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROUND"] = "Redondear un número hacia arriba o hacia abajo.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROUNDUP"] = "Redondear un número hacia arriba.";
  Blockly.Msg["MATH_SINGLE_TOOLTIP_ROUNDDOWN"] = "Redondear un número hacia hacia abajo.";
  Blockly.Msg["MATH_SINGLE_TRIG_ACOS"] = "acos";
  Blockly.Msg["MATH_SINGLE_TRIG_ASIN"] = "asin";
  Blockly.Msg["MATH_SINGLE_TRIG_ATAN"] = "atan";
  Blockly.Msg["MATH_SINGLE_TRIG_COS"] = "cos";
  Blockly.Msg["MATH_SINGLE_TRIG_SIN"] = "sin";
  Blockly.Msg["MATH_SINGLE_TRIG_TAN"] = "tan";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_ACOS"] = "Devuelve el arcocoseno de un número.";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_ASIN"] = "Devuelve el arcoseno de un número.";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_ATAN"] = "Devuelve el arcotangente de un número.";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_COS"] = "Devuelve el coseno de un grado (no radián).";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_SIN"] = "Devuelve el seno de un grado (no radián).";
  Blockly.Msg["MATH_SINGLE_TRIG_TOOLTIP_TAN"] = "Devuelve la tangente de un grado (no radián).";
  Blockly.Msg["MATH_SUBTRACTION_SYMBOL"] = "-";
  Blockly.Msg["MATH_TO_INT"] = "número entero";
  Blockly.Msg["MATH_TO_UINT"] = "número entero sin signo";
  Blockly.Msg["MATH_TRIG_ATAN2"] = "atan2";
  Blockly.Msg["MATH_TRIG_TOOLTIP_ATAN2"] = "Devuelve el arcotangente de y/x.";

  // Blocks - TEXT
  Blockly.Msg["TEXT_AS"] = Blockly.Msg["AS"];
  Blockly.Msg["TEXT_ASCII"] = "valor ASCII";
  Blockly.Msg["TEXT_CONTAINS"] = "contiene en el texto";
  Blockly.Msg["TEXT_CONTAINS_1"] = "cadena";
  Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TITLE_ITEM"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TOOLTIP"] = "Agregar un elemento al texto.";
  Blockly.Msg["TEXT_CREATE_JOIN_TITLE_JOIN"] = "unir";
  Blockly.Msg["TEXT_CREATE_JOIN_TOOLTIP"] = "Agregar, eliminar o reordenar las secciones para reconfigurar este bloque de texto.";
  Blockly.Msg["TEXT_DECIMAL"] = "decimales";
  Blockly.Msg["TEXT_ENDSWITH"] = "termina con";
  Blockly.Msg["TEXT_EQUALS"] = "igual a";
  Blockly.Msg["TEXT_EQUALS_IGNORE"] = "igual a (ignorar mayúsculas)";
  Blockly.Msg["TEXT_FORMAT"] = "formatear número";
  Blockly.Msg["TEXT_INDEXOF"] = "buscar en el texto";
  Blockly.Msg["TEXT_INDEXOF_1"] = "cadena";
  Blockly.Msg["TEXT_INDEXOF_FIRST"] = "primera";
  Blockly.Msg["TEXT_INDEXOF_LAST"] = "última";
  Blockly.Msg["TEXT_JOIN_TITLE_CREATEWITH"] = "crear texto con";
  Blockly.Msg["TEXT_JOIN_TOOLTIP"] = "Crear un fragmento de texto al unir cualquier número de elementos.";
  Blockly.Msg["TEXT_LENGTH_TITLE"] = "longitud de %1";
  Blockly.Msg["TEXT_LENGTH_TOOLTIP"] = "Devuelve el número de letras (incluyendo espacios) en el texto proporcionado.";
  Blockly.Msg["TEXT_NOT_EQUALS"] = "diferente de";
  Blockly.Msg["TEXT_REPLACE"] = "Reemplazar en texto";
  Blockly.Msg["TEXT_REPLACE_1"] = "cadena";
  Blockly.Msg["TEXT_REPLACE_2"] = "sustituto";
  Blockly.Msg["TEXT_STARTSWITH"] = "empieza con";
  Blockly.Msg["TEXT_SUBSTRING"] = "partir texto";
  Blockly.Msg["TEXT_SUBSTRING_1"] = "inicio";
  Blockly.Msg["TEXT_SUBSTRING_2"] = "fin";
  Blockly.Msg["TEXT_TEXT_TOOLTIP"] = "Una letra, palabra o línea de texto.";
  Blockly.Msg["TEXT_TONUMBER"] = "texto a número";
  Blockly.Msg["TEXT_WITH"] = "con";

  // Blocks - VARIABLES
  Blockly.Msg["VARIABLES_DEFAULT_NAME"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["VARIABLES_DEFAULT_NAME_BOOL"] = "varBool";
  Blockly.Msg["VARIABLES_DEFAULT_NAME_TEXT"] = "varTexto";
  Blockly.Msg["VARIABLES_GET_CREATE_SET"] = "Crear 'establecer %1'";
  Blockly.Msg["VARIABLES_GET_TOOLTIP"] = "Devuelve el valor de esta variable.";
  Blockly.Msg["VARIABLES_SET"] = "Establecer";
  Blockly.Msg["VARIABLES_SET_CREATE_GET"] = "Crear 'obtener %1'";
  Blockly.Msg["VARIABLES_SET_TOOLTIP"] = "Establece esta variable para que sea igual a la entrada.";

  // Blocks - LISTS
  Blockly.Msg["LISTS_CREATE_EMPTY_TITLE"] = "lista vacía";
  Blockly.Msg["LISTS_CREATE_TITLE"] = "Crear lista %1 %2 %3";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_NUMBER_WITH"] = "número ";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_TEXT_WITH"] = "texto ";
  Blockly.Msg["LISTS_CREATE_WITH_TOOLTIP"] = "Crea una lista con los elementos indicados.";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH"] = "Crear lista numérica";
  Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH_TEXT"] = "Crear lista de textos";
  Blockly.Msg["LISTS_CREATE_WITH_ITEM_TITLE"] = Blockly.Msg["DEFAULT_VAR_NAME"];
  Blockly.Msg["LISTS_GET_INDEX_GET"] = "obtener elemento";
  Blockly.Msg["LISTS_GET_INDEX_TOOLTIP"] = "Devuelve el elemento en el índice indicado.";
  Blockly.Msg["LISTS_SET_INDEX_TOOLTIP"] = "Establece un elemento en el índice indicado.";
  Blockly.Msg["LISTS_LENGTH_TITLE"] = "longitud de";
  Blockly.Msg["LISTS_LENGTH_TOOLTIP"] = "Devuelve la longitud de una lista.";
  Blockly.Msg["LISTS_LISTNAME"] = "listaNum";
  Blockly.Msg["LISTS_LISTNAME_TEXT"] = "listaTexto";
  Blockly.Msg["LISTS_SET_INDEX_SET"] = "establecer elemento";

  // Blocks - PROCEDURES
  Blockly.Msg["PROCEDURES_ALLOW_STATEMENTS"] = "permitir declaraciones";
  Blockly.Msg["PROCEDURES_BEFORE_PARAMS"] = "con:";
  Blockly.Msg["PROCEDURES_CALLNORETURN_TOOLTIP"] = "Ejecuta la función definida por el usuario '%1'.";
  Blockly.Msg["PROCEDURES_CALLRETURN_TOOLTIP"] = "Ejecuta la función definida por el usuario '%1' y usa su salida.";
  Blockly.Msg["PROCEDURES_CALL_BEFORE_PARAMS"] = "con:";
  Blockly.Msg["PROCEDURES_CREATE_DO"] = "Crear '%1'";
  Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"] = "Describe esta función…";
  Blockly.Msg["PROCEDURES_DEFNORETURN_DO"] = "";
  Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"] = "hacer algo";
  Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"] = "Para";
  Blockly.Msg["PROCEDURES_DEFNORETURN_TOOLTIP"] = "Crea una función sin salida.";
  Blockly.Msg["PROCEDURES_DEFRETURN_RETURN"] = "devuelve";
  Blockly.Msg["PROCEDURES_DEFRETURN_TOOLTIP"] = "Crea una función con una salida.";
  Blockly.Msg["PROCEDURES_DEF_DUPLICATE_WARNING"] = "Advertencia: Esta función tiene parámetros duplicados.";
  Blockly.Msg["PROCEDURES_HIGHLIGHT_DEF"] = "Destacar definición de la función";
  Blockly.Msg["PROCEDURES_IFRETURN_TOOLTIP"] = "Si un valor es cierto, develve el valor.";
  Blockly.Msg["PROCEDURES_IFRETURN_WARNING"] = "Aviso: Este bloque solo puede utlizarse dentro de la definición de una función.";
  Blockly.Msg["PROCEDURES_MUTATORARG_TITLE"] = "nombre de entrada:";
  Blockly.Msg["PROCEDURES_MUTATORARG_TOOLTIP"] = "Añadir una entrada a la función.";
  Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TITLE"] = "entradas";
  Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TOOLTIP"] = "Añadir, eliminar o reordenar entradas para esta función.";
  Blockly.Msg["PROCEDURES_VARIABLE"] = "argumento:";
  Blockly.Msg["PROCEDURES_DEFRETURN_COMMENT"] = Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"];
  Blockly.Msg["PROCEDURES_DEFRETURN_DO"] = Blockly.Msg["PROCEDURES_DEFNORETURN_DO"];
  Blockly.Msg["PROCEDURES_DEFRETURN_PROCEDURE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"];
  Blockly.Msg["PROCEDURES_DEFRETURN_TITLE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"];

  // Blocks - IO
  Blockly.Msg["IO_ANALOG_READ"] = "Leer PIN analógico";
  Blockly.Msg["IO_ANALOG_READ_DIF"] = "Leer analógica diferencial";
  Blockly.Msg["IO_ANALOG_WRITE"] = "Escribir PWM PIN analógico";
  Blockly.Msg["IO_CAPACITIVE_READ"] = "Leer entrada capacitiva";
  Blockly.Msg["IO_DIGITAL_READ"] = "Leer PIN digital";
  Blockly.Msg["IO_DIGITAL_WRITE"] = "Escribir PIN digital";
  Blockly.Msg["IO_INTERRUPT"] = "Interrupción";
  Blockly.Msg["IO_INT_RISING"] = "flanco de subida";
  Blockly.Msg["IO_INT_FALLING"] = "flanco de bajado";
  Blockly.Msg["IO_INT_CHANGE"] = "cambio de estado";
  Blockly.Msg["IO_INT_LOW"] = "estado en bajo";
  Blockly.Msg["IO_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["IO_PINMODE"] = "Configurar pin";
  Blockly.Msg["IO_PINMODE_AS"] = Blockly.Msg["AS"];
  Blockly.Msg["IO_PULSEIN"] = "Leer pulso";
  Blockly.Msg["IO_PULSEIN_TIMEOUT"] = "Tiempo de espera";
  Blockly.Msg["IO_VALUE"] = Blockly.Msg["VALUE"];

  // Blocks - TIME
  Blockly.Msg["TIME_MICROS"] = "microsegundos";
  Blockly.Msg["TIME_MILLIS"] = "milisegundos";
  Blockly.Msg["TIME_SECONDS"] = "segundos";
  Blockly.Msg["TIME_RUNEVERYMS"] = "Ejecutar cada";
  Blockly.Msg["TIME_SNOOZE"] = "Dormir";
  Blockly.Msg["TIME_TIMER"] = "Cronómetro";
  Blockly.Msg["TIME_TIMER_RESET"] = "Reiniciar el cronómetro";
  Blockly.Msg["TIME_TIME_ELAPSED_SECONDS"] = "Tiempo transcurrido en segundos";
  Blockly.Msg["TIME_TIME_ELAPSED_MILLI"] = "Tiempo transcurrido en milisegundos";
  Blockly.Msg["TIME_TIME_ELAPSED_MICRO"] = "Tiempo transcurrido en microsegundos";
  Blockly.Msg["TIME_WAIT"] = "Esperar";
  Blockly.Msg["TIME_WAIT_FOREVER"] = "Esperar por siempre FIN";
  Blockly.Msg["TIME_WAIT_UNTIL"] = "Esperar hasta que";
  Blockly.Msg["TIME_WAIT_WHILE"] = "Esperar mientras que";

  // Blocks - SERIAL
  Blockly.Msg["SERIAL"] = "Puerto Serie";
  Blockly.Msg["SERIAL_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["SERIAL_AVAILABLE"] = "¿Datos recibidos?";
  Blockly.Msg["SERIAL_BAUDRATE"] = Blockly.Msg["BAUDRATE"];
  Blockly.Msg["SERIAL_FIX"] = Blockly.Msg["FIX"];
  Blockly.Msg["SERIAL_FLUSH"] = "Vaciar datos";
  Blockly.Msg["SERIAL_INIT"] = "Iniciar";
  Blockly.Msg["SERIAL_INT"] = "Evento en el puerto";
  Blockly.Msg["SERIAL_PLOT_CREATE_TITLE"] = "Puerto Serie %1 Gráfica: %2 %3";
  Blockly.Msg["SERIAL_PLOT_CREATE_WITH_INPUT_NAME"] = "nombre ";
  Blockly.Msg["SERIAL_PLOT_CREATE_WITH_INPUT_NUMBER"] = "valor ";
  Blockly.Msg["SERIAL_PLOT_CREATE_WITH_TOOLTIP"] = "Gráfica para cualquier número de señales";
  Blockly.Msg["SERIAL_PLOT_CREATE_EMPTY_TITLE"] = "gráfica vacía";
  Blockly.Msg["SERIAL_PRINT"] = "Enviar";
  Blockly.Msg["SERIAL_PRINTLN"] = "Enviar línea";
  Blockly.Msg["SERIAL_READ"] = "Recibir";
  Blockly.Msg["SERIAL_READBYTE"] = "Recibir byte";
  Blockly.Msg["SERIAL_READFLOAT"] = "Recibir como número";
  Blockly.Msg["SERIAL_READINT"] = "Recibir como número entero";
  Blockly.Msg["SERIAL_READSTRING"] = "Recibir texto";
  Blockly.Msg["SERIAL_READSTRINGLINE"] = "Recibir línea de texto";
  Blockly.Msg["SERIAL_TIMEOUT"] = Blockly.Msg["TIMEOUT"];
  Blockly.Msg["SERIAL_UNTIL_NEW_LINE"] = Blockly.Msg["UNTIL_NEW_LINE"];
  Blockly.Msg["SERIAL_WRITEBYTE"] = "Enviar byte";

  // Blocks - SENSOR
  Blockly.Msg["SENSOR_ACCEL_ADXL345"] = "Acelerómetro (ADXL345)";
  Blockly.Msg["SENSOR_ACCEL_OFFSET"] = "Compensar";
  Blockly.Msg["SENSOR_BUTTON"] = "Pulsador";
  Blockly.Msg["SENSOR_BUTTON_DEBOUNCED"] = "Pulsador filtrado";
  Blockly.Msg["SENSOR_BUTTON_DEBOUNCED_PRESSED"] = "se ha pulsado";
  Blockly.Msg["SENSOR_BUTTON_DEBOUNCED_RELEASED"] = "se ha soltado";
  Blockly.Msg["SENSOR_BUTTON_INVERT"] = "Lógica invertida";
  Blockly.Msg["SENSOR_DHT11"] = "Sensor ambiental (DHT-11)";
  Blockly.Msg["SENSOR_DHT22"] = "Sensor ambiental (DHT-22)";
  Blockly.Msg["SENSOR_HUMIDITY"] = "Humedad %";
  Blockly.Msg["SENSOR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["SENSOR_POT"] = "Potenciómetro";
  Blockly.Msg["SENSOR_SOUND"] = "Micrófono";
  Blockly.Msg["SENSOR_TEMPERATURE"] = "Temperatura ºC";
  Blockly.Msg["SENSOR_TEMT6000"] = "Sensor de luz (TEMT6000)";
  Blockly.Msg["SENSOR_TILT"] = "Sensor de inclinación (TILT)";
  Blockly.Msg["SENSOR_TMP36"] = "Sensor de temperatura (TMP36)";
  Blockly.Msg["SENSOR_ULTRASONIC"] = "Sensor de distancia (HCSR-04)";
  Blockly.Msg["SENSOR_ULTRASONIC_MAXDISTANCE"] = "Max (cm)";
  Blockly.Msg["SENSOR_ULTRASONIC_UNITS"] = "Unidades";

  // Blocks - ACTUATOR
  Blockly.Msg["ACTUATOR_COLOUR"] = Blockly.Msg["COLOUR"];
  Blockly.Msg["ACTUATOR_COMMON_ANODE"] = "Ánodo común";
  Blockly.Msg["ACTUATOR_COMMON_CATHODE"] = "Cátodo común";
  Blockly.Msg["ACTUATOR_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["ACTUATOR_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["ACTUATOR_BUZZER"] = "Zumbador";
  Blockly.Msg["ACTUATOR_BUZZER_DURATION"] = "Duración";
  Blockly.Msg["ACTUATOR_BUZZER_FREQ"] = "Frecuencia";
  Blockly.Msg["ACTUATOR_BUZZER_TONE"] = "Tono";
  Blockly.Msg["ACTUATOR_NOTE_A"] = "LA";
  Blockly.Msg["ACTUATOR_NOTE_AS"] = "LA#";
  Blockly.Msg["ACTUATOR_NOTE_B"] = "SI";
  Blockly.Msg["ACTUATOR_NOTE_C"] = "DO";
  Blockly.Msg["ACTUATOR_NOTE_CS"] = "DO#";
  Blockly.Msg["ACTUATOR_NOTE_D"] = "RE";
  Blockly.Msg["ACTUATOR_NOTE_DS"] = "RE#";
  Blockly.Msg["ACTUATOR_NOTE_E"] = "MI";
  Blockly.Msg["ACTUATOR_NOTE_F"] = "FA";
  Blockly.Msg["ACTUATOR_NOTE_FS"] = "FA#";
  Blockly.Msg["ACTUATOR_NOTE_G"] = "SOL";
  Blockly.Msg["ACTUATOR_NOTE_GS"] = "SOL#";
  Blockly.Msg["ACTUATOR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["ACTUATOR_LED"] = "Led";
  Blockly.Msg["ACTUATOR_LED_PWM"] = "Led (PWM)";
  Blockly.Msg["ACTUATOR_RGBLED"] = "Led RGB";
  Blockly.Msg["ACTUATOR_SOUND_PLAY"] = "Reproducir";
  Blockly.Msg["ACTUATOR_STATUS"] = Blockly.Msg["STATUS"];
  Blockly.Msg["ACTUATOR_VALUE"] = Blockly.Msg["VALUE"];

  // Blocks - LCD
  Blockly.Msg["LCD"] = "Pantalla LCD";
  Blockly.Msg["LCD_BACKLIGHT"] = "Luz de fondo";
  Blockly.Msg["LCD_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["LCD_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["LCD_BLINK"] = "Parpadeo";
  Blockly.Msg["LCD_CLEAR"] = "Limpiar";
  Blockly.Msg["LCD_COL"] = Blockly.Msg["COL"];
  Blockly.Msg["LCD_CURSOR"] = "Cursor";
  Blockly.Msg["LCD_DEFINE"] = "Definir";
  Blockly.Msg["LCD_DISPLAY"] = "Mostrar";
  Blockly.Msg["LCD_EDITOR"] = "Editor de símbolo";
  Blockly.Msg["LCD_I2C_ADDRESS"] = Blockly.Msg["I2C_ADDRESS"];
  Blockly.Msg["LCD_I2C_BEGIN"] = Blockly.Msg["I2C_BEGIN"];
  Blockly.Msg["LCD_LEFT"] = "Izquierda";
  Blockly.Msg["LCD_RIGHT"] = "Derecha";
  Blockly.Msg["LCD_PRINT"] = "Imprimir";
  Blockly.Msg["LCD_ROW"] = Blockly.Msg["ROW"];
  Blockly.Msg["LCD_SCROLL"] = "Desplazar";
  Blockly.Msg["LCD_SYMBOL"] = "símbolo";
  Blockly.Msg["LCD_SYMBOL_UPCASE"] = "Símbolo";

  // Blocks - MATRIX
  Blockly.Msg["LEDMATRIX"] = "Matriz LED 8x8";
  Blockly.Msg["LEDMATRIX_CLEAR"] = "Limpiar";
  Blockly.Msg["LEDMATRIX_DRAWBITMAP"] = "Bitmap";
  Blockly.Msg["LEDMATRIX_DRAWCIRCLE"] = "Círculo";
  Blockly.Msg["LEDMATRIX_DRAWPIXEL"] = "Píxel";
  Blockly.Msg["LEDMATRIX_DRAWTEXT"] = "Texto";
  Blockly.Msg["LEDMATRIX_EDITOR"] = "Editor de bitmap";
  Blockly.Msg["LEDMATRIX_FILL"] = "Rellenar";
  Blockly.Msg["LEDMATRIX_HEIGHT"] = "Alto";
  Blockly.Msg["LEDMATRIX_ID"] = Blockly.Msg["ID"];
  Blockly.Msg["LEDMATRIX_I2C_ADDRESS"] = Blockly.Msg["I2C_ADDRESS"];
  Blockly.Msg["LEDMATRIX_I2C_BEGIN"] = Blockly.Msg["I2C_BEGIN"];
  Blockly.Msg["LEDMATRIX_INIT"] = "Iniciar";
  Blockly.Msg["LEDMATRIX_LED_ON"] = "Led ON";
  Blockly.Msg["LEDMATRIX_LED_OFF"] = "Led OFF";
  Blockly.Msg["LEDMATRIX_LINE"] = "Línea";
  Blockly.Msg["LEDMATRIX_RECTANGLE"] = "Rectángulo";
  Blockly.Msg["LEDMATRIX_ROTATION"] = "Rotar";
  Blockly.Msg["LEDMATRIX_ROUND"] = "Redondear";
  Blockly.Msg["LEDMATRIX_SHOW"] = "Mostrar";
  Blockly.Msg["LEDMATRIX_WIDTH"] = "Ancho";

  // Blocks - NEOPIXEL
  Blockly.Msg["NEOPIXEL"] = "NeoPixel";
  Blockly.Msg["NEOPIXEL_COLOUR"] = Blockly.Msg["COLOUR"];
  Blockly.Msg["NEOPIXEL_CLEAR"] = "Limpiar";
  Blockly.Msg["NEOPIXEL_INIT"] = "Iniciar";
  Blockly.Msg["NEOPIXEL_LEDCOUNT"] = "Número de ledes";
  Blockly.Msg["NEOPIXEL_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["NEOPIXEL_PIXEL"] = "Píxel";
  Blockly.Msg["NEOPIXEL_SETMATRIX"] = "Establecer matriz";
  Blockly.Msg["NEOPIXEL_SETPIXEL"] = "Establecer led";
  Blockly.Msg["NEOPIXEL_SETRAW"] = "Establecer datos";
  Blockly.Msg["NEOPIXEL_SHOW"] = "Mostrar";
  Blockly.Msg["NEOPIXEL_EXAMPLES"] = "Ejemplos";
  Blockly.Msg["NEOPIXEL_SPEED"] = "Velocidad";
  Blockly.Msg["NEOPIXEL_UNITS"] = "ms";
  Blockly.Msg["NEOPIXEL_COLOUR"] = "Color";
  Blockly.Msg["NEOPIXEL_RED"] = "R";
  Blockly.Msg["NEOPIXEL_GREEN"] = "G";
  Blockly.Msg["NEOPIXEL_BLUE"] = "B";
  Blockly.Msg["NEOPIXEL_RAINBOW"] = "Arcoiris";
  Blockly.Msg["NEOPIXEL_THEATER"] = "Teatro";
  Blockly.Msg["NEOPIXEL_WIPE"] = "Limpia";
  Blockly.Msg["NEOPIXEL_CHASE"] = "Destello";
  Blockly.Msg["NEOPIXEL_BRIGHTNESS"] = "Brillo";

  // Blocks - MOTOR
  Blockly.Msg["MOTOR_ID"] = Blockly.Msg["ID"];
  Blockly.Msg["MOTOR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["MOTOR_SERVO"] = "Servo";
  Blockly.Msg["MOTOR_SERVO_DEGREE_RANGE"] = "Grados";
  Blockly.Msg["MOTOR_SERVO_DELAY"] = "Retardo";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR"] = "Oscilador";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_AMPLITUDE"] = "Amplitud";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_OFFSET"] = "Desfase";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_PERIOD"] = "Período (ms)";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_PHASE"] = "Fase";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_REFRESH"] = "Actualizar";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_RESET"] = "Reiniciar";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_START"] = "Iniciar";
  Blockly.Msg["MOTOR_SERVO_OSCILLATOR_STOP"] = "Parar";
  Blockly.Msg["MOTOR_STEPPER"] = "Motor paso a paso";
  Blockly.Msg["MOTOR_STEPPER_RPM"] = "rpm";
  Blockly.Msg["MOTOR_STEPPER_SPEED"] = "Velocidad";
  Blockly.Msg["MOTOR_STEPPER_START"] = "Iniciar";
  Blockly.Msg["MOTOR_STEPPER_STEP"] = "Pasos";
  Blockly.Msg["MOTOR_STEPPER_STEPS"] = "Pasos/Vuelta";
  Blockly.Msg["MOTOR_DC_MOTOR_DC"] = "Motor DC";
  Blockly.Msg["MOTOR_DC_MOTOR"] = "Motor";
  Blockly.Msg["MOTOR_DC_BEGIN"] = "Iniciar";
  Blockly.Msg["MOTOR_DC_STOP"] = "Parar";
  Blockly.Msg["MOTOR_DC_DIRECTION"] = "Dirección";
  Blockly.Msg["MOTOR_DC_FORDWARD"] = "Adelante";
  Blockly.Msg["MOTOR_DC_SPEED"] = "Velocidad";
  Blockly.Msg["MOTOR_DC_BACKWARD"] = "Atrás";

  // Blocks - RTC
  Blockly.Msg["RTC"] = "Reloj digital";
  Blockly.Msg["RTC_DATE_TEXT"] = "Fecha";
  Blockly.Msg["RTC_DAY"] = "Día";
  Blockly.Msg["RTC_DAYOFWEEK"] = "Día de la semana";
  Blockly.Msg["RTC_FRIDAY"] = "Viernes";
  Blockly.Msg["RTC_HOUR"] = "Hora";
  Blockly.Msg["RTC_MINUTE"] = "Minuto";
  Blockly.Msg["RTC_MONDAY"] = "Lunes";
  Blockly.Msg["RTC_MONTH"] = "Mes";
  Blockly.Msg["RTC_SATURDAY"] = "Sábado";
  Blockly.Msg["RTC_SECOND"] = "Segundo";
  Blockly.Msg["RTC_SUNDAY"] = "Domingo";
  Blockly.Msg["RTC_THURSDAY"] = "Jueves";
  Blockly.Msg["RTC_TIME_TEXT"] = "Hora";
  Blockly.Msg["RTC_TUESDAY"] = "Martes";
  Blockly.Msg["RTC_WEDNESDAY"] = "Miércoles";
  Blockly.Msg["RTC_YEAR"] = "Año";

  // Blocks - SD
  Blockly.Msg["SD"] = "Tarjeta SD";
  Blockly.Msg["SD_DO"] = Blockly.Msg["DO"];
  Blockly.Msg["SD_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["SD_BEGIN"] = "Iniciar";
  Blockly.Msg["SD_EXISTS"] = "¿Existe el archivo?";
  Blockly.Msg["SD_POS"] = "Posición";
  Blockly.Msg["SD_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["SD_PRINT"] = "Archivos datos";
  Blockly.Msg["SD_FILE"] = "Archivo";
  Blockly.Msg["SD_READBYTE"] = "Leer byte";
  Blockly.Msg["SD_READLOOP"] = "Leer cada byte";
  Blockly.Msg["SD_REMOVE"] = "Eliminar archivo";
  Blockly.Msg["SD_SIZE"] = "Tamaño de archivo";
  Blockly.Msg["SD_WRITEBYTE"] = "Escribir byte";
  Blockly.Msg["SD_FORMAT"] = "Formatear";
  Blockly.Msg["SD_FORMAT_QUICK"] = "Formateo rápido";
  Blockly.Msg["SD_ERASE"] = "Borrar";
  Blockly.Msg["SD_WRITE"] = "Escribir";

  // Blocks - BLUETOOTH
  Blockly.Msg["BLUETOOTH"] = "Bluetooth";
  Blockly.Msg["BLUETOOTH_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["BLUETOOTH_AVAILABLE"] = "¿Datos recibidos?";
  Blockly.Msg["BLUETOOTH_BAUDRATE"] = Blockly.Msg["BAUDRATE"];
  Blockly.Msg["BLUETOOTH_DEVNAME"] = "Cambiar nombre";
  Blockly.Msg["BLUETOOTH_FIX"] = Blockly.Msg["FIX"];
  Blockly.Msg["BLUETOOTH_INIT"] = "Iniciar";
  Blockly.Msg["BLUETOOTH_PIN"] = "Código PIN";
  Blockly.Msg["BLUETOOTH_PRINT"] = "Enviar";
  Blockly.Msg["BLUETOOTH_PRINTLN"] = "Enviar texto línea";
  Blockly.Msg["BLUETOOTH_READBYTE"] = "Recibir byte";
  Blockly.Msg["BLUETOOTH_READFLOAT"] = "Recibir como número";
  Blockly.Msg["BLUETOOTH_READSTRING"] = "Recibir texto";
  Blockly.Msg["BLUETOOTH_READSTRINGLINE"] = "Recibir línea de texto";
  Blockly.Msg["BLUETOOTH_TIMEOUT"] = Blockly.Msg["TIMEOUT"];
  Blockly.Msg["BLUETOOTH_UNTIL_NEW_LINE"] = Blockly.Msg["UNTIL_NEW_LINE"];
  Blockly.Msg["BLUETOOTH_WRITEBYTE"] = "Enviar byte";

  // Blocks - BLYNK BLYNK_WIFI
  Blockly.Msg["BLYNK_ADD_NEW_LINE"] = Blockly.Msg["ADD_NEW_LINE"];
  Blockly.Msg["BLYNK_APP_CONNECTED"] = "App conectada";
  Blockly.Msg["BLYNK_APP_DISCONNECTED"] = "App desconectada";
  Blockly.Msg["BLYNK_APP_READ"] = "Valor requerido";
  Blockly.Msg["BLYNK_APP_WRITE"] = "Valor recibido";
  Blockly.Msg["BLYNK_AUTH"] = "Código autentificación";
  Blockly.Msg["BLYNK_BAUDRATE"] = Blockly.Msg["BAUDRATE"];
  Blockly.Msg["BLYNK_BOOLEAN_OFF"] = Blockly.Msg["BOOLEAN_OFF"];
  Blockly.Msg["BLYNK_BOOLEAN_ON"] = Blockly.Msg["BOOLEAN_ON"];
  Blockly.Msg["BLYNK_CONNECTED"] = "Conectado al servidor";
  Blockly.Msg["BLYNK_INIT"] = "Iniciar";
  Blockly.Msg["BLYNK_LCD_CLEAR"] = "Limpiar";
  Blockly.Msg["BLYNK_LCD_COL"] = Blockly.Msg["COL"];
  Blockly.Msg["BLYNK_LCD_PRINT"] = "Imprimir";
  Blockly.Msg["BLYNK_LCD_ROW"] = Blockly.Msg["ROW"];
  Blockly.Msg["BLYNK_LED"] = "Led";
  Blockly.Msg["BLYNK_LED_INTENSITY"] = "Brillo";
  Blockly.Msg["BLYNK_LOCALPORT"] = "Puerto";
  Blockly.Msg["BLYNK_LOCALSERVER"] = "IP servidor";
  Blockly.Msg["BLYNK_GPS"] = "GPS localización";
  Blockly.Msg["BLYNK_GPS_LAT"] = "Latitud";
  Blockly.Msg["BLYNK_GPS_LONG"] = "Longitud";
  Blockly.Msg["BLYNK_PARAM_READ_INT"] = "Valor del PIN";
  Blockly.Msg["BLYNK_PARAM_READ_STRING"] = "Valor textual";
  Blockly.Msg["BLYNK_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["BLYNK_SET_PROPERTY"] = "Fijar propiedad";
  Blockly.Msg["BLYNK_TERMINAL_CLEAR"] = "limpiar";
  Blockly.Msg["BLYNK_TERMINAL_PRINT"] = "Imprimir";
  Blockly.Msg["BLYNK_TIMER"] = "Temporizador";
  Blockly.Msg["BLYNK_VIRTUALWRITE"] = "Escribir PIN";
  Blockly.Msg["BLYNK_VPIN_VALUE"] = "Valor";
  Blockly.Msg["BLYNK_WIFI"] = "Wifi";
  Blockly.Msg["BLYNK_WIFI_NAME"] = "SSID";
  Blockly.Msg["BLYNK_WIFI_PASS"] = "Contraseña";

  // Blocks - IFTTT 
  Blockly.Msg["IFTTT_WEBHOOKS_KEY"] = "Clave Webhooks: ";
  Blockly.Msg["IFTTT_EMAIL_TITLE"] = "Wifi %1 Evento de correo: %2 %3";
  Blockly.Msg["IFTTT_EMAIL_TOOTLTIP"] = "Correo con valores";
  Blockly.Msg["IFTTT_EMAIL_VALUE"] = "valor ";
  Blockly.Msg["IFTTT_SMS_EVENT"] = "Evento SMS:";
  Blockly.Msg["IFTTT_TWEET_EVENT"] = "Evento Tweet:";
  Blockly.Msg["IFTTT_TELEGRAM_EVENT"] = "Evento Telegram:";

  // Blocks - THINGER
  Blockly.Msg["THINGER_USERID"] = "ID de usuario: ";
  Blockly.Msg["THINGER_DEVICEID"] = "ID de dispositivo: ";
  Blockly.Msg["THINGER_AUTH"] = "Autorización: ";
  Blockly.Msg["THINGER_UPLOAD_TITLE"] = "Wifi %1 Subir: %2 %3";
  Blockly.Msg["THINGER_UPLOAD"] = Blockly.Msg["UPLOAD"];
  Blockly.Msg["THINGER_UPLOAD_TOOLTIP"] = "Subir los valores";

  // Blocks - THINGSPEAK
  Blockly.Msg["THINGSPEAK_WRITE_APIKEY"] = "Escribir clave API: ";
  Blockly.Msg["THINGSPEAK_UPLOAD_TITLE"] = "Wifi %1 Subir: %2 %3";
  Blockly.Msg["THINGSPEAK_UPLOAD_FIELD"] = "campo ";

  // Blocks - MQTT (no publicado)
  Blockly.Msg["MQTT_BROKER"] = "Broker";
  Blockly.Msg["MQTT_CLIENTID"] = "Cliente Id";
  Blockly.Msg["MQTT_INIT"] = "Iniciar";
  Blockly.Msg["MQTT_ISCONNECTED"] = "¿está conectado?";
  Blockly.Msg["MQTT_MAC"] = "MAC";
  Blockly.Msg["MQTT_PASS"] = "Clave";
  Blockly.Msg["MQTT_PORT"] = "Puerto";
  Blockly.Msg["MQTT_PUB"] = "Publicar";
  Blockly.Msg["MQTT_SUB"] = "Suscribir";
  Blockly.Msg["MQTT_TOPIC"] = "Tema";
  Blockly.Msg["MQTT_USER"] = "Usuario";
  Blockly.Msg["MQTT_VALUE"] = "Valor";
  Blockly.Msg["MQTT_WIFI_NAME"] = "red";
  Blockly.Msg["MQTT_WIFI_PASS"] = "clave";

  // Blocks - INFRARED
  Blockly.Msg["IR"] = "IR";
  Blockly.Msg["IR_PIN"] = Blockly.Msg["PIN"];
  Blockly.Msg["IR_RX"] = "Receptor";
  Blockly.Msg["IR_RX_NUMBER"] = "Recibir número en";
  Blockly.Msg["IR_TX"] = "Emisor";
  Blockly.Msg["IR_TX_BITS"] = "#Bits";
  Blockly.Msg["IR_TX_CODE"] = "Código";
  Blockly.Msg["IR_TX_DATA"] = "Dato";
  Blockly.Msg["IR_TX_NUMBER"] = "Emitir número en";
  Blockly.Msg["IR_TX_PROTOCOL"] = "Protocolo";

  // Workspace
  Blockly.Msg["ADD_COMMENT"] = "Añadir comentario";
  Blockly.Msg["UNDO"] = "Deshacer";
  Blockly.Msg["REDO"] = "Rehacer";
  Blockly.Msg["VARIABLE_ALREADY_EXISTS"] = "Ya existe una variable con el nombre '%1'.";
  Blockly.Msg["VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE"] = "Ya existe una variable con en nombre '%1' definida como tipo: '%2'.";
  Blockly.Msg["CHANGE_VALUE_TITLE"] = "Cambiar el valor:";
  Blockly.Msg["CLEAN_UP"] = "Ordenar los bloques";
  Blockly.Msg["COLLAPSE_ALL"] = "Contraer bloques";
  Blockly.Msg["COLLAPSE_BLOCK"] = "Contraer bloque";
  Blockly.Msg["DELETE_ALL_BLOCKS"] = "¿Eliminar todos los %1 bloques?";
  Blockly.Msg["DELETE_BLOCK"] = "Eliminar bloque";
  Blockly.Msg["DELETE_X_BLOCKS"] = "Eliminar %1 bloques";
  Blockly.Msg["DELETE_VARIABLE"] = "Borrar '%1'";
  Blockly.Msg["DELETE_VARIABLE_CONFIRMATION"] = "¿Eliminar %1 usos de la '%2' variable?";
  Blockly.Msg["DISABLE_BLOCK"] = "Desactivar bloque";
  Blockly.Msg["DUPLICATE_BLOCK"] = "Duplicar";
  Blockly.Msg["DUPLICATE_COMMENT"] = "Duplicar comentario";
  Blockly.Msg["ENABLE_BLOCK"] = "Activar bloque";
  Blockly.Msg["EXPAND_ALL"] = "Expandir bloques";
  Blockly.Msg["EXPAND_BLOCK"] = "Expandir bloque";
  Blockly.Msg["EXTERNAL_INPUTS"] = "Entradas externas";
  Blockly.Msg["HELP"] = "Ayuda";
  Blockly.Msg["INLINE_INPUTS"] = "Entradas en línea";
  Blockly.Msg["NEW_VARIABLE"] = "Crear…";
  Blockly.Msg["NEW_VARIABLE_TITLE"] = "Nombre de la variable nueva:";
  Blockly.Msg["REMOVE_COMMENT"] = "Eliminar comentario";
  Blockly.Msg["RENAME_VARIABLE"] = "Renombrar…";
  Blockly.Msg["RENAME_VARIABLE_TITLE"] = "Renombrar todas las variables «%1» a:";
  Blockly.Msg["WORKSPACE_COMMENT_DEFAULT_TEXT"] = "Tu comentario…";

  // Backpack
  Blockly.Msg["COPY_ALL_TO_BACKPACK"] = "Copia todos los bloques a la mochila";
  Blockly.Msg["COPY_TO_BACKPACK"] = "Copiar a la mochila";
  Blockly.Msg["EMPTY_BACKPACK"] = "Vacía";
  Blockly.Msg["PASTE_ALL_FROM_BACKPACK"] = "Copia todos los bloques a la mochila";
  Blockly.Msg["REMOVE_FROM_BACKPACK"] = "Borrar de la mochila";

  return Blockly.Msg;
}
